export const services = [
  {
    title: 'Design & Build',
    blurb: 'Full design-build delivery of commercial buildings from concept through closeout.',
  },
  {
    title: 'Concrete Structures & Pads',
    blurb: 'Foundations, slabs, equipment pads, and structural concrete built to spec.',
  },
  {
    title: 'Commercial Remodeling',
    blurb: 'Interior and exterior renovations executed around active operations.',
  },
  {
    title: 'Structural Steel & PEB',
    blurb: 'Structural steel erection and pre-engineered metal building construction.',
  },
  {
    title: 'Commercial Roofing',
    blurb: 'Roof replacement, re-roofing, and repairs across large multi-building portfolios.',
  },
  {
    title: 'Mechanical & Plumbing',
    blurb: 'Facility mechanical systems, HVAC, and plumbing installation and repair.',
  },
  {
    title: 'Painting & Flooring',
    blurb: 'Commercial-grade coatings and flooring systems for high-traffic environments.',
  },
  {
    title: 'Fire Suppression',
    blurb: 'Fire suppression system installation, upgrades, and code compliance work.',
  },
  {
    title: 'Project & Site Management',
    blurb: 'Site management, ongoing facility maintenance, and solar installation support.',
  },
];
